(function () {
  'use strict';

  const HEAD_SRC = 'https://cdn.shopify.com/s/files/1/0625/5309/6236/files/HEAD_WITH_EYES.png?v=1779861801';

  const isMobile = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0);

  function setInstructions() {
    const el = document.getElementById('bb-sub');
    if (el) el.textContent = isMobile
      ? 'Tap to launch · drag paddle to move'
      : 'Move mouse to aim · click to launch';
  }

  const canvas = document.getElementById('bb-canvas');
  if (!canvas) return;
  const ctx = canvas.getContext('2d');

  const headImg = new Image();
  headImg.src = HEAD_SRC;

  // ── State ─────────────────────────────────────────────────────────────────
  let W, H;
  let gameState = 'idle';
  let lives = 3, level = 1;
  let animFrame = null;
  let particles = [];
  let fireworkTick = 0;
  let loseAnimT = 0;
  let blocksAlive = 0;
  const MAX_PARTICLES = 90;

  // ── Paddle ────────────────────────────────────────────────────────────────
  const PAD = { w: 0, h: 14, x: 0, y: 0, speed: 0 };

  // ── Ball ──────────────────────────────────────────────────────────────────
  const ball = {
    x: 0, y: 0, vx: 0, vy: 0,
    r: 0,        // set in resize()
    angle: 0,
    launched: false,
    sx: 1, sy: 1,
    spawnT: 1,   // 0→1 spawn animation; 1 = fully visible
  };

  // ── Bricks ────────────────────────────────────────────────────────────────
  let bricks = [];
  const COLS = 10, ROWS = 10;
  const BRICK_GAP = 5;
  const ROW_COLORS = ['#ff278c'];

  // ── Input ─────────────────────────────────────────────────────────────────
  const keys = {};
  let touchX = null;
  let mouseX = null;

  // ── Konami code cheat ─────────────────────────────────────────────────────
  const KONAMI = ['ArrowUp','ArrowUp','ArrowDown','ArrowDown','ArrowLeft','ArrowRight','ArrowLeft','ArrowRight'];
  let konamiBuf = [];

  // ── Resize / layout ───────────────────────────────────────────────────────
  function resize() {
    const dpr = Math.min(window.devicePixelRatio || 1, 2);
    W = canvas.clientWidth;
    H = canvas.clientHeight;
    canvas.width  = Math.round(W * dpr);
    canvas.height = Math.round(H * dpr);
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

    // Scale everything to viewport
    ball.r   = Math.round(Math.min(W, H) * 0.055);
    PAD.w    = Math.round(W * 0.28);
    PAD.h    = Math.round(Math.min(W, H) * 0.022);
    PAD.speed = Math.round(W * 0.025);
    PAD.y    = H - Math.round(H * 0.06);

    if (!ball.launched) resetBall();
    makeBricks();
  }

  function makeBricks() {
    bricks = [];
    const brickTop  = Math.round(H * 0.06);
    const brickAreaH = Math.round(H * 0.55);
    const brickH    = Math.floor((brickAreaH - BRICK_GAP * (ROWS + 1)) / ROWS);
    const totalGap  = BRICK_GAP * (COLS + 1);
    const bW        = Math.floor((W - totalGap) / COLS);

    for (let r = 0; r < ROWS; r++) {
      const hp     = 1;
      const bounce = false;
      for (let c = 0; c < COLS; c++) {
        bricks.push({
          x: BRICK_GAP + c * (bW + BRICK_GAP),
          y: brickTop  + r * (brickH + BRICK_GAP),
          w: bW, h: brickH,
          color: ROW_COLORS[Math.min(r, ROW_COLORS.length - 1)],
          hp, maxHp: hp, alive: true, bounce,
        });
      }
    }
    blocksAlive = bricks.length;
  }

  function resetBall() {
    PAD.x  = W / 2 - PAD.w / 2;
    ball.x = W / 2;
    ball.y = PAD.y - ball.r - 2;
    ball.vx = 0; ball.vy = 0;
    ball.angle = 0; ball.launched = false;
    ball.sx = 1; ball.sy = 1;
    ball.spawnT = 0;
  }

  function easeOutBack(t) {
    const c1 = 1.70158, c3 = c1 + 1;
    return 1 + c3 * Math.pow(t - 1, 3) + c1 * Math.pow(t - 1, 2);
  }

  function launch() {
    if (ball.launched) return;
    ball.launched = true;
    const diag  = Math.hypot(W, H);
    const spd   = diag * (isMobile ? 0.010 : 0.006) + level * diag * 0.0004;
    const angle = -Math.PI / 2 + (Math.random() - 0.5) * 0.85;
    ball.vx = Math.cos(angle) * spd;
    ball.vy = Math.sin(angle) * spd;
  }

  // ── Update ────────────────────────────────────────────────────────────────
  function update() {
    // Single backwards pass: update + cull without allocating a new array
    for (let i = particles.length - 1; i >= 0; i--) {
      const p = particles[i];
      p.vx *= p.drag; p.vy *= p.drag;
      p.x += p.vx; p.y += p.vy; p.vy += p.gravity; p.life--;
      p.r = p.maxR * (p.life / p.maxLife);
      if (p.life <= 0) { particles[i] = particles[particles.length - 1]; particles.pop(); }
    }

    if (gameState === 'won') {
      fireworkTick++;
      if (fireworkTick % 90 === 0) {
        spawnFirework(W * (0.1 + Math.random() * 0.8), H * (0.1 + Math.random() * 0.5));
      }
      return;
    }

    if (gameState !== 'playing') return;

    if (ball.spawnT < 1) ball.spawnT = Math.min(1, ball.spawnT + 1 / 18);

    // Mouse paddle (desktop)
    if (mouseX !== null) {
      const rect = canvas.getBoundingClientRect();
      PAD.x = Math.max(0, Math.min(W - PAD.w, (mouseX - rect.left) - PAD.w / 2));
    }

    // Touch paddle (mobile)
    if (touchX !== null) {
      const rect = canvas.getBoundingClientRect();
      PAD.x = Math.max(0, Math.min(W - PAD.w, (touchX - rect.left) - PAD.w / 2));
    }

    if (!ball.launched) {
      ball.x = PAD.x + PAD.w / 2;
      ball.y = PAD.y - ball.r - 2;
      return;
    }

    // Squish recovery
    ball.sx += (1 - ball.sx) * 0.18;
    ball.sy += (1 - ball.sy) * 0.18;

    ball.x += ball.vx;
    ball.y += ball.vy;
    ball.angle += Math.hypot(ball.vx, ball.vy) * 0.035 * Math.sign(ball.vx || 1);

    // Walls
    if (ball.x - ball.r < 0)  { ball.x = ball.r;     ball.vx =  Math.abs(ball.vx); squish(true); }
    if (ball.x + ball.r > W)  { ball.x = W - ball.r;  ball.vx = -Math.abs(ball.vx); squish(true); }
    if (ball.y - ball.r < 0)  { ball.y = ball.r;      ball.vy =  Math.abs(ball.vy); squish(false); }

    // Paddle
    if (ball.vy > 0 &&
        ball.y + ball.r >= PAD.y &&
        ball.y + ball.r <= PAD.y + PAD.h + Math.abs(ball.vy) + 2 &&
        ball.x >= PAD.x - 4 && ball.x <= PAD.x + PAD.w + 4) {
      ball.y = PAD.y - ball.r;
      const rel    = (ball.x - (PAD.x + PAD.w / 2)) / (PAD.w / 2);
      const curSpd = Math.hypot(ball.vx, ball.vy);
      const diag   = Math.hypot(W, H);
      const newSpd = Math.min(curSpd * 1.02, diag * (isMobile ? 0.022 : 0.013) + level * diag * 0.0004);
      ball.vx = rel * newSpd * 0.9;
      ball.vy = -Math.sqrt(Math.max(1, newSpd * newSpd - ball.vx * ball.vx));
      squish(false);
    }

    // Bricks
    for (const br of bricks) {
      if (!br.alive) continue;
      const cx = Math.max(br.x, Math.min(ball.x, br.x + br.w));
      const cy = Math.max(br.y, Math.min(ball.y, br.y + br.h));
      if (Math.hypot(ball.x - cx, ball.y - cy) >= ball.r) continue;

      br.hp--;
      if (br.hp <= 0) { br.alive = false; blocksAlive--; spawnParticles(br); }
      updateHUD();
      if (br.bounce) {
        const overL = ball.x + ball.r - br.x;
        const overR = br.x + br.w - (ball.x - ball.r);
        const overT = ball.y + ball.r - br.y;
        const overB = br.y + br.h - (ball.y - ball.r);
        const m = Math.min(overL, overR, overT, overB);
        if (m === overT || m === overB) { ball.vy *= -1; squish(false); }
        else                           { ball.vx *= -1; squish(true); }
        break;
      }
    }

    // Win
    if (blocksAlive === 0) {
      triggerWin();
    }

    // Lose ball
    if (ball.y - ball.r > H) {
      loseLife();
    }
  }

  function triggerWin() {
    gameState = 'won';
    fireworkTick = 0;
    particles = [];
    bricks.forEach(b => { b.alive = false; });
    // Burst of fireworks immediately
    for (let i = 0; i < 6; i++) {
      spawnFirework(W * (0.1 + Math.random() * 0.8), H * (0.15 + Math.random() * 0.55));
    }
    // Show win overlay after brief fireworks display
    setTimeout(showWinOverlay, 900);
  }

  function squish(horiz) {
    if (horiz) { ball.sx = 0.65; ball.sy = 1.35; }
    else       { ball.sx = 1.35; ball.sy = 0.65; }
  }

  function spawnParticles(br) {
    if (particles.length >= MAX_PARTICLES) return;
    const count = Math.min(6, MAX_PARTICLES - particles.length);
    for (let i = 0; i < count; i++) {
      const a = Math.random() * Math.PI * 2;
      const s = 1 + Math.random() * 4;
      particles.push({
        x: br.x + br.w / 2, y: br.y + br.h / 2,
        vx: Math.cos(a) * s, vy: Math.sin(a) * s - 1.5,
        color: br.color,
        maxR: 3 + Math.random() * 3, r: 3,
        life: 30, maxLife: 30,
        drag: 1, gravity: 0.2,
      });
    }
  }

  const FIREWORK_COLORS = ['#ff278c', '#ff0080', '#ff3399', '#ff1a8c', '#ff4daa', '#ff006a'];

  function spawnFirework(x, y) {
    const count = Math.min(16, MAX_PARTICLES - particles.length);
    if (count <= 0) return;
    for (let i = 0; i < count; i++) {
      const a = (i / count) * Math.PI * 2 + (Math.random() - 0.5) * 0.4;
      const s = 6 + Math.random() * 7;
      const life = 55 + Math.floor(Math.random() * 25);
      particles.push({
        x, y,
        vx: Math.cos(a) * s,
        vy: Math.sin(a) * s - 2,
        color: FIREWORK_COLORS[Math.floor(Math.random() * FIREWORK_COLORS.length)],
        maxR: 5.5 + Math.random() * 4, r: 5.5,
        life, maxLife: life,
        drag: 0.91, gravity: 0.04,
      });
    }
  }

  function spawnHeartBurst(x, y) {
    const count = Math.min(12, MAX_PARTICLES - particles.length);
    if (count <= 0) return;
    for (let i = 0; i < count; i++) {
      const a = (i / count) * Math.PI * 2 + (Math.random() - 0.5) * 0.5;
      const s = 4 + Math.random() * 5;
      const life = 45 + Math.floor(Math.random() * 20);
      particles.push({
        x, y,
        vx: Math.cos(a) * s,
        vy: Math.sin(a) * s - 1.5,
        color: FIREWORK_COLORS[Math.floor(Math.random() * FIREWORK_COLORS.length)],
        maxR: 4 + Math.random() * 3, r: 4,
        life, maxLife: life,
        drag: 0.90, gravity: 0.06,
      });
    }
  }

  function loseLife() {
    lives--;
    updateHUD();
    gameState = 'losing';
    loseAnimT = 0;

    const canvasRect = canvas.getBoundingClientRect();
    let startX, startY;
    const livesEl = document.getElementById('bb-lives');
    const slots   = livesEl ? livesEl.querySelectorAll('.bb-heart-slot') : null;
    const srcSlot = slots && slots[lives] ? slots[lives] : livesEl;
    if (srcSlot) {
      const lr = srcSlot.getBoundingClientRect();
      startX = lr.left + lr.width  / 2;
      startY = lr.top  + lr.height / 2;
    } else {
      startX = canvasRect.left + canvasRect.width / 2;
      startY = canvasRect.top  + 24;
    }
    const endX = canvasRect.left + canvasRect.width  / 2;
    const endY = canvasRect.top  + canvasRect.height / 2;

    const flyHeart = document.createElement('span');
    flyHeart.textContent = '♥︎';
    flyHeart.style.cssText = 'position:fixed;pointer-events:none;z-index:2147483647;font-size:30px;font-weight:bold;color:#ff278c;line-height:1;transform:translate(-50%,-50%) scaleY(0.81);';
    flyHeart.style.left = startX + 'px';
    flyHeart.style.top  = startY + 'px';
    document.body.appendChild(flyHeart);

    function burst() {
      flyHeart.remove();
      loseAnimT = 0;
      spawnHeartBurst(W / 2, H / 2);
      if (lives <= 0) {
        gameState = 'gameover';
        setTimeout(() => showOverlay('GAME OVER', '', 'PLAY AGAIN'), 500);
      } else {
        resetBall();
        gameState = 'playing';
      }
    }

    const duration = 650;
    const t0 = performance.now();
    function animHeart(now) {
      const t    = Math.min(1, (now - t0) / duration);
      const ease = t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
      loseAnimT  = t;

      flyHeart.style.left = (startX + (endX - startX) * ease) + 'px';
      flyHeart.style.top  = (startY + (endY - startY) * ease) + 'px';

      // Shake ramps up quadratically; baked into the heart's transform
      const shakeOff = (14 * t * t) * Math.sin(now * 0.072);
      flyHeart.style.transform = 'translate(calc(-50% + ' + shakeOff + 'px), -50%) scale(' + (1 + ease * 2.5) + ') scaleY(0.81)';

      if (t < 1) {
        requestAnimationFrame(animHeart);
      } else {
        // Snap to exact center — clear any shake offset before the hold
        flyHeart.style.left      = endX + 'px';
        flyHeart.style.top       = endY + 'px';
        flyHeart.style.transform = 'translate(-50%, -50%) scale(3.5) scaleY(0.81)';
        setTimeout(burst, 300);
      }
    }
    requestAnimationFrame(animHeart);
  }

  // ── Draw ──────────────────────────────────────────────────────────────────
  function draw() {
    // Always clear to white so flash tint can't accumulate across frames
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, W, H);

    // Bricks — track last color to minimise state changes
    let lastColor = null;
    ctx.globalAlpha = 1;
    for (const br of bricks) {
      if (!br.alive) continue;
      const color = br.hp < br.maxHp ? '#ff72b8' : br.color;
      if (color !== lastColor) { ctx.fillStyle = color; lastColor = color; }
      ctx.fillRect(br.x, br.y, br.w, br.h);
    }

    // White tint during life-loss — fades bricks so the burst pops
    if (gameState === 'losing' && loseAnimT > 0) {
      ctx.fillStyle = 'rgba(255,255,255,' + Math.min(0.8, loseAnimT * 0.95) + ')';
      ctx.fillRect(0, 0, W, H);
    }

    // Particles
    for (const p of particles) {
      ctx.globalAlpha = p.life / p.maxLife;
      ctx.fillStyle = p.color;
      ctx.beginPath(); ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2); ctx.fill();
    }
    ctx.globalAlpha = 1;

    if (gameState !== 'won') {
      // Paddle
      ctx.fillStyle = '#ffffff';
      rrect(PAD.x, PAD.y, PAD.w, PAD.h, PAD.h / 2); ctx.fill();
      ctx.strokeStyle = '#ff278c'; ctx.lineWidth = 2.5; ctx.stroke();

      // Head
      ctx.save();
      ctx.translate(ball.x, ball.y);
      ctx.rotate(ball.angle);
      const spawnScale = easeOutBack(ball.spawnT);
      ctx.scale(ball.sx * spawnScale, ball.sy * spawnScale);
      if (headImg.complete && headImg.naturalWidth) {
        ctx.drawImage(headImg, -ball.r, -ball.r * 1.05, ball.r * 2, ball.r * 2.1);
      } else {
        ctx.beginPath(); ctx.arc(0, 0, ball.r, 0, Math.PI * 2);
        ctx.fillStyle = '#ff278c'; ctx.fill();
      }
      ctx.restore();
    }

    // Level-up
    if (gameState === 'levelup') {
      ctx.fillStyle = 'rgba(255,255,255,0.85)';
      ctx.fillRect(0, 0, W, H);
      ctx.fillStyle = '#ff278c';
      ctx.font = 'bold ' + Math.round(W * 0.1) + 'px system-ui,sans-serif';
      ctx.textAlign = 'center';
      ctx.fillText('LEVEL ' + level, W / 2, H / 2 - 16);
      ctx.fillStyle = '#666';
      ctx.font = Math.round(W * 0.04) + 'px system-ui,sans-serif';
      ctx.fillText('get ready…', W / 2, H / 2 + 24);
    }
  }

  function rrect(x, y, w, h, r) {
    ctx.beginPath();
    ctx.moveTo(x + r, y);
    ctx.lineTo(x + w - r, y); ctx.arcTo(x + w, y, x + w, y + r, r);
    ctx.lineTo(x + w, y + h - r); ctx.arcTo(x + w, y + h, x + w - r, y + h, r);
    ctx.lineTo(x + r, y + h); ctx.arcTo(x, y + h, x, y + h - r, r);
    ctx.lineTo(x, y + r); ctx.arcTo(x, y, x + r, y, r);
    ctx.closePath();
  }

  // ── HUD / Overlay ─────────────────────────────────────────────────────────
  function updateHUD() {
    const el = id => document.getElementById(id);
    if (el('bb-blocks')) el('bb-blocks').textContent = blocksAlive;
    if (el('bb-lives')) {
      let html = '';
      for (let i = 0; i < 3; i++) {
        html += '<span class="bb-heart-slot"' + (i >= lives ? ' style="opacity:0"' : '') + '>♥︎</span>';
      }
      el('bb-lives').innerHTML = html;
    }
  }

  function showOverlay(title, sub, btn) {
    document.getElementById('bb-title').textContent = title;
    document.getElementById('bb-sub').textContent   = sub;
    document.getElementById('bb-btn').textContent   = btn;
    const overlayEl = document.getElementById('bb-overlay');
    overlayEl.style.background = '';
    overlayEl.style.opacity    = '0';
    overlayEl.style.display    = 'flex';
    // Double-rAF ensures the browser paints opacity:0 before transitioning to 1
    requestAnimationFrame(() => requestAnimationFrame(() => {
      overlayEl.style.opacity = '1';
    }));
  }

  function showWinOverlay() {
    const titleEl   = document.getElementById('bb-title');
    const subEl     = document.getElementById('bb-sub');
    const btnEl     = document.getElementById('bb-btn');
    const overlayEl = document.getElementById('bb-overlay');
    if (titleEl) { titleEl.textContent = 'YOU WIN!'; titleEl.style.fontSize = 'clamp(28px, 9vw, 48px)'; }
    if (subEl)     subEl.innerHTML     = '<span class=”bb-win-desc”>10% DISCOUNT APPLIED AT CHECKOUT</span>';
    if (btnEl)     btnEl.textContent   = 'START SHOPPING';
    if (overlayEl) {
      overlayEl.style.background = 'linear-gradient(to top, transparent 25%, rgba(255,255,255,0.82) 55%)';
      overlayEl.style.opacity    = '0';
      overlayEl.style.display    = 'flex';
      requestAnimationFrame(() => requestAnimationFrame(() => {
        overlayEl.style.opacity = '1';
      }));
    }
    // Silently apply the discount so it's active at checkout
    fetch('/discount/WINNER').catch(() => {});
  }

  function hideOverlay() {
    const overlayEl = document.getElementById('bb-overlay');
    overlayEl.style.background = '';
    overlayEl.style.opacity    = '0';
    overlayEl.style.display    = 'none';
  }

  // ── Loop ──────────────────────────────────────────────────────────────────
  function loop() { update(); draw(); animFrame = requestAnimationFrame(loop); }

  function startGame() {
    lives = 3; level = 1;
    particles = []; fireworkTick = 0;
    makeBricks(); updateHUD();
    // Position ball on paddle without resetting spawnT so it stays visible
    PAD.x = W / 2 - PAD.w / 2;
    ball.x = W / 2; ball.y = PAD.y - ball.r - 2;
    ball.vx = 0; ball.vy = 0;
    ball.angle = 0; ball.launched = false; ball.sx = 1; ball.sy = 1;
    gameState = 'playing';
    hideOverlay();
    if (!animFrame) loop();
  }

  // ── Events ────────────────────────────────────────────────────────────────
  document.addEventListener('keydown', e => {
    keys[e.key] = true;
    if ([' ', 'ArrowUp'].includes(e.key)) e.preventDefault();
    if ((e.key === ' ' || e.key === 'ArrowUp') && gameState === 'playing') launch();

    // Konami cheat: up up down down left right left right
    if (e.key.startsWith('Arrow')) {
      konamiBuf.push(e.key);
      if (konamiBuf.length > KONAMI.length) konamiBuf.shift();
      if (konamiBuf.length === KONAMI.length && konamiBuf.every((k, i) => k === KONAMI[i])) {
        konamiBuf = [];
        if (gameState === 'playing' || gameState === 'idle') triggerWin();
      }
    }
  });
  document.addEventListener('keyup', e => { delete keys[e.key]; });

  canvas.addEventListener('mousemove', e => { mouseX = e.clientX; });
  canvas.addEventListener('mouseleave', () => { mouseX = null; });
  canvas.addEventListener('click', () => { if (gameState === 'playing') launch(); });

  canvas.addEventListener('touchstart', e => {
    e.preventDefault();
    touchX = e.touches[0].clientX;
    if (gameState === 'playing') launch();
  }, { passive: false });
  canvas.addEventListener('touchmove', e => {
    e.preventDefault();
    touchX = e.touches[0].clientX;
  }, { passive: false });
  canvas.addEventListener('touchend', () => { touchX = null; });

  document.getElementById('bb-btn')?.addEventListener('click', () => {
    if (gameState === 'won') {
      document.querySelector('.sc-bb-close-x')?.click();
    } else {
      startGame();
    }
  });

  window.addEventListener('resize', () => { resize(); if (!ball.launched) resetBall(); });

  setInstructions();

  window.BrickBreaker = {
    start() {
      if (animFrame) { cancelAnimationFrame(animFrame); animFrame = null; }
      lives = 3; level = 1;
      particles = []; fireworkTick = 0;
      gameState = 'idle';
      makeBricks();
      resetBall();
      const titleEl   = document.getElementById('bb-title');
      const btnEl     = document.getElementById('bb-btn');
      const overlayEl = document.getElementById('bb-overlay');
      if (titleEl) { titleEl.innerHTML = 'CLEAR THE BLOCKS,<br>WIN A DISCOUNT!'; titleEl.style.fontSize = ''; }
      if (btnEl)     btnEl.textContent   = 'PLAY';
      setInstructions();
      if (overlayEl) {
        overlayEl.style.background = '';
        overlayEl.style.display = 'flex';
      }
      resize();
      updateHUD();
      loop();
    },
    startReady() {
      this.start();
      ball.spawnT = 1;
    },
    stop() {
      if (animFrame) { cancelAnimationFrame(animFrame); animFrame = null; }
      gameState = 'idle';
    },
  };
})();
